export function prizeCategoryImageLink(fileName) {
  return 'http://localhost:8001/uploads/prizeCategoriesImages/' + fileName;
}